<div class="ion-text-left">
  @if (label) {
    <ion-label [ngClass]="baseCssClass">
      {{ label }}
    </ion-label>
  }

  <ion-item [disabled]="disabled" [ngClass]="{ 'ion-margin-vertical': isMediumOrLarge() }" [lines]="disabled ? 'none' : 'full'">
    @if (icon) {
      <ion-icon [name]="icon" slot="start" color="gray"></ion-icon>
    }
    <ion-input
      [ngClass]="[baseCssClass, !!errorText ? 'ion-invalid' : '']"
      [disabled]="disabled"
      value="{{ readOnlyValue }}"
      (ionChange)="onInputChange($event)"
      (ionInput)="onInputChange($event)"
    [placeholder]="getPlaceholderValue()"></ion-input>
  </ion-item>
  @if (errorText) {
    <ion-text class="error-text" color="danger">{{ errorText }}</ion-text>
  }
</div>
